import {observer} from 'mobx-react';
import React, {useContext, useEffect, useState} from 'react';
import {StateContext} from '../../App';
import {getDisplayTimeBySeconds} from '../../services/timer-service.js';

const Timer = observer(({seconds}) => {
    const {timer} = useContext(StateContext);
    seconds = seconds || timer.seconds;

    const updatedDisplayTime = getDisplayTimeBySeconds(seconds);

    return <span>{updatedDisplayTime}</span>;
});

export default Timer;
